import { Space, SpaceProps } from 'antd'

export interface KBSpaceProps extends SpaceProps {}

export const KBSpace = forwardRef<HTMLDivElement, KBSpaceProps>(
  (props, ref) => {
    return <Space ref={ref} {...props}></Space>
  }
)
